export interface FeedbackModel {
  senderName: string;
  senderEmail: string;
  message: string;
  userId?: string;
}

export const emptyFeedback = (): FeedbackModel => {
  return {
    senderName: "",
    senderEmail: "",
    message: "",
    userId: null
  }
}